module.exports = __webpack_public_path__ + "img/album-none.288940db.svg";